import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import { TableComp } from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { Button, Card, Form, Row, Col, Tooltip, DatePicker, Select, Drawer, notification } from 'antd';
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import Request, { API_URL } from '../../request'
import { connect } from 'react-redux'
import StaffLeaveAction from '../../components/_utils/staffLeaveAction.js'
import moment from 'moment'
import AddStaffLeave from '../../components/_utils/addStaffLeave';
import { RightsWrapper } from '../../components/_utils/utils'
import UpdateAppraisal from '../../components/_utils/updateAppraisal';
import SalarySlipAction from '../../components/_utils/salarySlipAction.js';

const { MonthPicker } = DatePicker
const Option = Select.Option;



@Form.create()
class StaffSalarySlips extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        defaultPageSize: 20,
        month: moment(),
        activityArr: [],
        oldLeaves: [],
        record: {},
        allUsers: [],
        userId: null,
        showLeaveActionForm: false,
        showAppraisalAddForm: false,
        showAppraisalEditForm: false,
        showSalarySlipActionForm: false,
    }



    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleStaffLeaveApplication = (record) => {
        this.setState({ showLeaveActionForm: true, record: record })
    }

    handleSalarySlipActionClose = () => {
        this.setState({ showSalarySlipActionForm: false, record: {} })
        this.table.current.reload()
    }

    handleAdd = () => {
        this.setState({ showAppraisalAddForm: true })
    }

    handleClose = () => {
        this.setState({ showLeaveAddForm: false })
        this.reload()
    }

    onClose = () => {
        this.setState({ showAppraisalAddForm: false, record: {}, viewDetailRecord: {}, showAppraisalEditForm: false })
        this.reload()
    }

    apiRequest = params => {
        return new Promise(async (resolve) => {
            params.sortField = "createdByUser.time";
            params.sortOrder = "descend";
            let response = await Request.getStaffSalarySlipRequests(params);
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    handleSlipRequest = (data) => {
        this.setState({ record: data, showSalarySlipActionForm: true })
    }



    handleSlipRequest = (data) => {
        this.setState({ record: data, showSalarySlipActionForm: true })
    }

    async componentDidMount() {
        let params = {
            sortField: '_id',
            sortOrder: 'ascend',
            results: 200,
            active: true,
            userType: { $ne: "Student" },
        };

        let response = await Request.loadUser({ ...params, regExFilters: ['name'] })
        let userArray = [];
        response.data.map((user, index) => {
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({ allUsers: userArray })
    }

    reload = () => {
        this.table.current.reload();
    };

    render() {
        const { defaultPageSize, count, record, allUsers, showSalarySlipActionForm, showAppraisalEditForm } = this.state
        const columns = [
            {
                title: 'Employee Name',
                key: 'userId.name',
            },
            {
                title: 'From',
                key: 'monthFrom',
                render: (text, record) => (
                    <div>{record && moment(record.monthFrom).format('DD-MMMM-YYYY')}</div>
                )
            },
            {
                title: 'To',
                key: 'monthTo',
                render: (text, record) => (
                    <div>{record && moment(record.monthTo).format('DD-MMMM-YYYY')}</div>
                )
            },
            {
                title: 'Status',
                key: 'status'
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <RightsWrapper myRight={'salarySlipRequest.edit'}>
                        <React.Fragment>
                            <Tooltip title="Edit Request">
                                <Button
                                    size={"small"}
                                    shape="circle"
                                    onClick={() => this.handleSlipRequest(record)}
                                    icon="edit"
                                />
                            </Tooltip>&nbsp;
                        </React.Fragment>
                    </RightsWrapper>
                ),
            }
        ]


        return (
            <PageHeaderWrapper title={`Staff Salary Slip Requests:- ${count}`}>
                {
                    showSalarySlipActionForm ?
                        <SalarySlipAction record={record} onClose={this.handleSalarySlipActionClose} />
                        : null
                }
                <Card bordered={true} >
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: defaultPageSize,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffSalarySlips)
